import { Box, Tooltip } from "@mui/material";
import { Check as DoneIcon, TriangleAlert as WarningIcon } from "lucide-react";

export const loanHubspotFormatter = (value: boolean | undefined | null) => {
  if (value) {
    return (
      <Tooltip title="Hubspot is up to date!">
        <Box display="inline-flex">
          <DoneIcon style={{ marginTop: 5 }} color="#2CB666" />
        </Box>
      </Tooltip>
    );
  } else {
    return (
      <Tooltip title="Hubspot requires sync!">
        <Box display="inline-flex">
          <WarningIcon style={{ marginTop: 5 }} color="#ed6c02" />
        </Box>
      </Tooltip>
    );
  }
};
